import { render, staticRenderFns } from "./SwiperComponent.vue?vue&type=template&id=2aa20da8&scoped=true"
import script from "./SwiperComponent.vue?vue&type=script&lang=js"
export * from "./SwiperComponent.vue?vue&type=script&lang=js"
import style0 from "./SwiperComponent.vue?vue&type=style&index=0&id=2aa20da8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa20da8",
  null
  
)

export default component.exports